import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EventDetailPage from './pages/EventDetailPage';
import BookingPage from './pages/BookingPage';
import MyTicketsPage from './pages/MyTicketsPage';
import TicketVerifyPage from './pages/TicketVerifyPage';
import OrgLoginPage from './pages/OrgLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import BookingSuccessPage from './pages/BookingSuccessPage';
import ManagerDashboard from './pages/manager/ManagerDashboard';

function Layout() {
  const location = useLocation();
  const isAdmin   = location.pathname.startsWith('/admin');
  const isManager = location.pathname.startsWith('/manage');
  const isLogin   = location.pathname === '/organiser-login';
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"                        element={<HomePage />} />
        <Route path="/events/:slug"            element={<EventDetailPage />} />
        <Route path="/book/:slug/:tierId/:qty" element={<BookingPage />} />
        <Route path="/booking/success/:ref" element={<BookingSuccessPage />} />
        <Route path="/my-tickets"              element={<MyTicketsPage />} />
        <Route path="/verify/:uid"             element={<TicketVerifyPage />} />
        <Route path="/organiser-login"         element={<OrgLoginPage />} />
        <Route path="/admin/tickets"           element={<AdminDashboard />} />
        <Route path="/admin/tickets/:s"        element={<AdminDashboard />} />
        <Route path="/manage"                  element={<ManagerDashboard />} />
        <Route path="/manage/:s"               element={<ManagerDashboard />} />
      </Routes>
      {!isAdmin && !isManager && !isLogin && <Footer />}
    </>
  );
}

export default function App() {
  return <BrowserRouter><Layout /></BrowserRouter>;
}